import { Role } from '@/types/Role'
import { useAuth } from '../context/AuthContext'
import { Navigate } from 'react-router-dom'
import { JSX } from 'react'
import Loading from '@/components/Loading/Loading'

interface RequireAuthProps {
    children: JSX.Element
    roles: Role[]
}

export function RequireAuth({ children, roles }: Readonly<RequireAuthProps>): JSX.Element {
    const { user, loadingAuth } = useAuth()

    if (loadingAuth) {
        return <Loading overall />
    }

    if (user?.role && roles.includes(user.role)) {
        return children
    }

    return <Navigate to='/' replace />
}
